import { render, staticRenderFns } from "./zCep.vue?vue&type=template&id=67644a5c&scoped=true"
import script from "./zCep.vue?vue&type=script&lang=js"
export * from "./zCep.vue?vue&type=script&lang=js"
import style0 from "./zCep.vue?vue&type=style&index=0&id=67644a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67644a5c",
  null
  
)

export default component.exports